/*global BMS*/
import React, {Component} from 'react';
import {connect} from 'react-redux';
import style from '../css/main.css';
// components import TopBar from './topBar';
import RaceCard from './raceCard';
import VideoPlayer from './videoPlayer';
import ChipsModal from '../components/chipsModal';
import GameTabs from '../../sharedComponents/containers/gameTabs';
import ModalPopup from '../../sharedComponents/containers/modalPopup';
import BetHistory from '../../sharedComponents/containers/betHistory';
import HelpPages from '../../sharedComponents/containers/helpPages';
import Settings from '../../sharedComponents/containers/settings';
// constants
import {CHIPS_LIST_MODAL_TYPE, NOTIFICATION_MODAL_TYPE} from '../../../../constants/identifiers';

const mapStateToProps = (state, ownProps) => {
    return {
        isModalOpen: state.vpp.isModalOpen,
        openModalType: state.vpp.openModalType,
        isBetHistoryOpen: state.vpp.isBetHistoryOpen,
        isHelpPagesOpen: state.vpp.isHelpPagesOpen,
        isSettingsOpen: state.vpp.isSettingsOpen,
        isVideoVisible: state.vpp.isVideoVisible
    };
};

class Main extends Component {

    constructor(props) {
        super(props);

        let store = this.props.store;
        let storeData = store.getState();

        this.state = {
            isModalOpen: storeData.vpp.isModalOpen,
            openModalType: storeData.vpp.openModalType,
            isBetHistoryOpen: storeData.vpp.isBetHistoryOpen,
            isHelpPagesOpen: storeData.vpp.isHelpPagesOpen,
            isSettingsOpen: storeData.vpp.isSettingsOpen,
            isVideoVisible: storeData.vpp.isVideoVisible
        };

        BMS.Operator.init();
    }

    componentWillReceiveProps(nextProps) {
        let store = nextProps.store;
        let storeData = store.getState();

        if (nextProps && storeData) {
            this.setState({
                isModalOpen: storeData.vpp.isModalOpen,
                openModalType: storeData.vpp.openModalType,
                isBetHistoryOpen: storeData.vpp.isBetHistoryOpen,
                isHelpPagesOpen: storeData.vpp.isHelpPagesOpen,
                isSettingsOpen: storeData.vpp.isSettingsOpen,
                isVideoVisible: storeData.vpp.isVideoVisible
            });
        }
    }

    render() {
        let modal;

        if (this.state.isModalOpen) {
            switch (this.state.openModalType) {
                case CHIPS_LIST_MODAL_TYPE:
                    modal = (<ChipsModal store={this.props.store}/>);
                    break;
                case NOTIFICATION_MODAL_TYPE:
                    modal = (<ModalPopup id='notificationPopup' store={this.props.store}
                                         modalType={NOTIFICATION_MODAL_TYPE}/>);
                    break;
                default:
                    break;
            }
        }

        let betHistory;
        if (this.state.isBetHistoryOpen) {
            betHistory = (<BetHistory store={this.props.store}/>);
        }

        let helpPages;
        if (this.state.isHelpPagesOpen) {
            helpPages = (<HelpPages store={this.props.store}/>);
        }

        let settings;
        if (this.state.isSettingsOpen) {
            settings = (<Settings store={this.props.store}/>);
        }

        return (<div className={style.mainContent} id={'Simplified-UI-Mobile-Container'}>
            {/* <TopBar store={this.props.store}/> */}
            <GameTabs store={this.props.store}/> {
            this.state.isVideoVisible
                ? <VideoPlayer store={this.props.store}/>
                : ''
        }
            <RaceCard store={this.props.store}/> {modal}
            {betHistory}
            {helpPages}
            {settings}
        </div>);
    }
}

export default connect(mapStateToProps)(Main);



// WEBPACK FOOTER //
// ./src/ui-modules/simplified/mobile/containers/main.js